import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { deleteRequest, fetcher, postData, putData, patchData } from "util/fetch";
// import useLocalStorage from 'hooks/useLocalStorage';

const AdminContext = React.createContext();

const AdminProvider = (props) => {
  const [shops, setShops] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingShops, setLoadingShops] = useState(false);
  const [loadingShopData, setLoadingShopData] = useState(false);
  const [
    loadingEmailPickupInstructions,
    setLoadingEmailPickupInstructions,
  ] = useState(false);
  const [orders, setOrders] = useState({ entities: {}, shops: {} });
  // const [products, setProducts] = useState({ entities: {}, shops: {} });
  const [deliveries, setDeliveries] = useState({ entities: {}, shops: {} });
  const [rates, setRates] = useState();
  const [saving, setSaving] = useState(false);
  const [registerError, setRegisterError] = useState();
  const [selectedShopId, setSelectedShopId] = useState();
  const [shippingLabels, setShippingLabels] = useState({});
  const [toast, setToast] = useState();
  const history = useHistory();
  const [confirmation, setConfirmation] = useState();

  const selectedShop =
    shops && shops.find((shop) => shop.id === +selectedShopId);

  const fetchShippingLabels = async (orderId) => {
    try {
      const res = await fetcher(
        `/api/shops/${selectedShopId}/orders/${orderId}/shipping_labels`
      );
      const labels = await res.json();
      setShippingLabels({
        ...shippingLabels,
        [orderId]: labels,
      });
    } catch (error) {
      console.log({ error });
    }
  };

  const registerShop = async (shop) => {
    setSaving(true);
    try {
      const res = await postData("/api/shops", { shop });
      const newShop = await res.json();
      setShops([newShop, ...shops]);
      history.push(`/shops/${newShop.id}`);
      setRegisterError(null);
    } catch (error) {
      console.log({ error });
      setRegisterError(error);
    } finally {
      setSaving(false);
    }
  };

  const updateShop = (partial) => {
    return putData(`/api/shops/${selectedShopId}`, {
      shop: { ...selectedShop, ...partial },
    })
      .then((res) => res.json())
      .then((updated) => {
        setShops(
          shops.map((existing) =>
            existing.id === selectedShopId ? updated : existing
          )
        );
        setToast("Shop updated");
        setRates();
      });
  };

  const fetchRates = async (shopId) => {
    try {
      setLoading(true);
      // todo: allow sending custom packages
      const res = await postData(`/api/shops/${shopId}/rates`, {
        packages: [],
      });
      const data = await res.json();
      setRates(data);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedShopId) {
      return;
    }

    const fetchOrdersAndDeliveries = () => {
      setLoading(true);
      Promise.all([
        fetcher(`/api/shops/${selectedShopId}/orders?include_recent_unfulfilled=true`).then((res) =>
          res.json()
        ),
        fetcher(`/api/shops/${selectedShopId}/deliveries`).then((res) =>
          res.json()
        ),
      ])
        .then(([orders, deliveries]) => {
          setOrders((state) => {
            const entities = orders.reduce(
              (acc, d) => ({ ...acc, [d.id]: d }),
              state.entities
            );
            return {
              entities: {
                ...state.entities,
                ...entities,
              },
              shops: {
                ...state.shops,
                [selectedShopId]: orders.map((r) => r.id),
              },
            };
          });

          setDeliveries((state) => {
            const entities = deliveries.reduce(
              (acc, d) => ({ ...acc, [d.shopify_order_id]: d }),
              state.entities
            );
            return {
              entities: {
                ...state.entities,
                ...entities,
              },
              shops: {
                ...state.shops,
                [selectedShopId]: deliveries.map((r) => r.shopify_order_id),
              },
            };
          });
        })
        .catch((error) => console.log({ error }))
        .finally(() => setLoading(false));
    };

    fetchOrdersAndDeliveries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedShopId]);

  const updateOrder = (order) => {
    setOrders((state) => {
      return {
        ...state,
        entities: {
          ...state.entities,
          [order.id]: order,
        },
      };
    });
  };

  // const searchProducts = async (query) => {
  //   try {
  //     setLoadingProducts(true);
  //     const res = await fetcher(`/api/shops/${selectedShop.id}/products?query=${encodeURIComponent(query)}`);
  //     return await res.json();
  //   } catch (error) {
  //     console.log({ error });
  //   } finally {
  //     setLoadingProducts(false)
  //   }
  // }

  // useEffect(() => {
  //   if (!selectedShop || loadingProducts || products.shops[selectedShop.id]) {
  //     return;
  //   }

  //   const fetchProducts = async () => {
  //     try {
  //       setLoadingProducts(true);
  //       const res = await fetcher(`/api/shops/${selectedShop.id}/products`);
  //       const response = await res.json();
  //       if (response.length > 0) {
  //         setProducts(state => {
  //           const entities = response.reduce((acc, d) => ({ ...acc, [d.product_id]: d }), state.entities)
  //           return {
  //             entities,
  //             shops: {
  //               ...state.shops,
  //               [selectedShop.id]: response.map(p => p.id)
  //             }
  //           }
  //         });
  //       }
  //     } catch (error) {
  //       console.log({ error });
  //     } finally {
  //       setLoadingProducts(false)
  //     }
  //   }

  //   fetchProducts();
  // }, [selectedShop, products, loadingProducts]);

  useEffect(() => {
    if (!selectedShop) {
      return;
    }

    const fetchShopData = async () => {
      try {
        setLoadingShopData(true);
        console.debug(
          '[Admin] Fetching shop detail payloads',
          {
            shopId: selectedShop.id,
            shopDomain: selectedShop?.shopify_domain,
          }
        );

        const res = await Promise.all([
          fetcher(`/api/shops/${selectedShop.id}/locations`).then((res) =>
            res.json().then((json) => {
              console.debug('[Admin] Locations response', {
                shopId: selectedShop.id,
                locationsCount: Array.isArray(json) ? json.length : 'n/a',
                locations: json,
              });
              return json;
            })
          ),
          fetcher(`/api/shops/${selectedShop.id}/service_windows`).then((res) =>
            res.json().then((json) => {
              console.debug('[Admin] Service windows response', {
                shopId: selectedShop.id,
                availableWindowsCount: json?.available_windows?.length,
                serviceWindowsCount: json?.service_windows?.length,
              });
              return json;
            })
          ),
          fetcher(`/api/shops/${selectedShop.id}/products/types`).then((res) =>
            res.json().then((json) => {
              console.debug('[Admin] Product types response', {
                shopId: selectedShop.id,
                productTypesCount: Array.isArray(json) ? json.length : 'n/a',
              });
              return json;
            })
          ),
        ]);
        const locations = res[0];
        const { available_windows, service_windows } = res[1];
        const productTypes = res[2];

        console.debug('[Admin] Updating shop state with new payloads', {
          shopId: selectedShop.id,
          locationsCount: Array.isArray(locations) ? locations.length : 'n/a',
          availableWindowsCount: available_windows?.length,
          serviceWindowsCount: service_windows?.length,
          productTypesCount: Array.isArray(productTypes) ? productTypes.length : 'n/a',
        });

        setShops((s) =>
          s.map((shop) =>
            shop.id === selectedShop.id
              ? {
                  ...shop,
                  locations,
                  available_windows,
                  service_windows,
                  productTypes,
                }
              : shop
          )
        );
      } catch (error) {
        console.error('[Admin] Error fetching shop data', {
          shopId: selectedShop?.id,
          error,
        });
      } finally {
        setLoadingShopData(false);
      }
    };

    if (
      !selectedShop.available_windows ||
      !selectedShop.locations ||
      !selectedShop.productTypes
    ) {
      fetchShopData();
    }
  }, [shops, selectedShop]);

  // useEffect(() => {
  //   console.log({ products })
  // }, [products]);

  const sortShops = (shops) => {
    return shops.sort((a, b) =>
      a.current.name.toLowerCase() < b.current.name.toLowerCase() ? -1 : 1
    );
  };

  const fetchShops = async () => {
    setLoadingShops(true);
    try {
      const res = await fetcher("/api/shops");

      // Check if response is ok (status 200-299)
      if (!res.ok) {
        console.error(`API Error: ${res.status} ${res.statusText}`);
        throw new Error(`Server returned ${res.status}: ${res.statusText}`);
      }

      // Check if response is actually JSON by examining content-type
      const contentType = res.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        console.error("Server returned non-JSON response:", contentType);
        const textResponse = await res.text();
        console.error("Response body:", textResponse.substring(0, 500) + "...");
        throw new Error(
          "Server returned HTML instead of JSON. This usually indicates a server error."
        );
      }

      const fetched = await res.json();

      // Sort shops alphabetically by name
      if (!fetched) {
        setToast(
          `There was an issue loading shops. Please wait a moment and try again.`
        );
        setShops([]);
        window.location.pathname = "/auth/login";
        setLoadingShops(false);
      } else {
        setShops(sortShops(fetched));
      }
    } catch (error) {
      console.error("fetchShops error:", error);

      // Handle specific error types with user-friendly messages
      let errorMessage =
        "There was an issue loading shops. Please wait a moment and try again.";

      if (error.message.includes("JSON")) {
        errorMessage =
          "Server is experiencing technical difficulties. Please try refreshing the page or contact support if the issue persists.";
      } else if (error.message.includes("500")) {
        errorMessage =
          "Server error detected. The development team has been notified. Please try again in a few minutes.";
      } else if (error.message.includes("HTML instead of JSON")) {
        errorMessage =
          "Server configuration issue detected. Please refresh the page or contact support.";
      }

      setToast(errorMessage);
      setShops([]);

      // Only redirect to login if it's an authentication issue (401/403)
      if (error.message.includes("401") || error.message.includes("403")) {
        window.location.pathname = "/auth/login";
      }

      setLoadingShops(false);
    } finally {
      setLoadingShops(false);
    }
  };

  const configureShop = async () => {
    try {
      setLoading(true);
      const res = await fetcher(`/api/shops/${selectedShopId}/configure`);
      const body = await res.json();
      // 422 + webhook_failures: the carrier registered but some webhook topics did not.
      const webhookFailures =
        res.status === 422 && Array.isArray(body.webhook_failures)
          ? body.webhook_failures
          : null;
      if (!res.ok && !webhookFailures) throw new Error(`${res.status}`);

      const fetched = webhookFailures ? body.shop : body;
      setShops((s) =>
        s.map((shop) => (shop.id === selectedShopId ? fetched : shop))
      );
      if (webhookFailures) {
        const topics = webhookFailures.map((f) => f.topic).join(", ");
        setToast(
          `Carrier registered, but these webhooks failed to register: ${topics}. Try again, and contact support if it keeps failing.`
        );
      } else {
        setToast("Webhooks and carrier registered.");
      }
    } catch (error) {
      setToast(
        "Error configuring webhooks and carrier. Ensure that Carrier Calculated Rates is enabled for this shop."
      );
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  const navigateExternal = (url) =>
    window.open(url, "_blank") || window.location.replace(url);

  const navigateToShopify = (path) => {
    const url = `//${selectedShop.shopify_domain}/${path}`;
    navigateExternal(url);
  };

  const saveDeliveryRate = (deliveryRate) => {
    return postData(`/api/shops/${selectedShopId}/shop_config/delivery_rates`, {
      delivery_rate: deliveryRate,
    })
      .then((res) => res.json())
      .then((delivery_rates) => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId
              ? {
                  ...shop,
                  shop_config: {
                    ...shop.shop_config,
                    delivery_rates,
                  },
                }
              : shop
          )
        );
        setToast("Delivery rate saved.");
      })
      .catch((error) => {
        setToast(`Error saving delivery rate: ${error.message}`);
      });
  };

  const deleteDeliveryRate = (deliveryRate) => {
    const idOrName = deliveryRate.id || encodeURIComponent(deliveryRate.name);
    return deleteRequest(
      `/api/shops/${selectedShopId}/shop_config/delivery_rates/${idOrName}`
    )
      .then((res) => res.json())
      .then(() => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId
              ? {
                  ...shop,
                  shop_config: {
                    ...shop.shop_config,
                    delivery_rates: shop.shop_config.delivery_rates.filter(
                      (d) =>
                        (deliveryRate.id && d.id !== deliveryRate.id) ||
                        (!deliveryRate.id && d.name !== deliveryRate.name)
                    ),
                  },
                }
              : shop
          )
        );
        setToast("Delivery rate deleted.");
      })
      .catch((error) => {
        setToast(`Error deleting delivery rate: ${error.message}`);
      });
  };

  const updateStoreDeliveryPostalCodes = (data) => {
    return patchData(
      `/api/shops/${selectedShopId}/shop_config/store_delivery_postal_codes`,
      data
    )
      .then((res) => res.json())
      .then((updatedFields) => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId
              ? {
                  ...shop,
                  shop_config: {
                    ...shop.shop_config,
                    store_delivery_include_postal_codes: updatedFields.include_postal_codes,
                    store_delivery_exclude_postal_codes: updatedFields.exclude_postal_codes,
                  },
                }
              : shop
          )
        );
        setToast("Postal code settings saved.");
      });
  };

  const updateSamedayCutoffs = (data) => {
    return patchData(
      `/api/shops/${selectedShopId}/shop_config/sameday_cutoffs`,
      data
    )
      .then((res) => res.json())
      .then((updatedFields) => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId
              ? {
                  ...shop,
                  shop_config: {
                    ...shop.shop_config,
                    sameday_cutoff_time_delivery: updatedFields.sameday_cutoff_time_delivery,
                    sameday_cutoff_time_pickup: updatedFields.sameday_cutoff_time_pickup,
                  },
                }
              : shop
          )
        );
        setToast("Same-day cutoff times saved.");
        return updatedFields;
      })
      .catch((error) => {
        setToast(`Error saving cutoff times: ${error.message}`);
        throw error;
      });
  };

  const saveAvailabilityRule = (availability_rule) => {
    return postData(
      `/api/shops/${selectedShopId}/shop_config/availability_rules`,
      { availability_rule }
    )
      .then((res) => res.json())
      .then((availability_rules) => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId
              ? {
                  ...shop,
                  shop_config: {
                    ...shop.shop_config,
                    availability_rules,
                  },
                }
              : shop
          )
        );
        setToast("Availability rule saved.");
      });
  };

  const deleteAvailabilityRule = (type, value) => {
    return deleteRequest(
      `/api/shops/${selectedShopId}/shop_config/availability_rules/${encodeURIComponent(
        type
      )}/${encodeURIComponent(value)}`
    )
      .then((res) => res.json())
      .then((availability_rules) => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId
              ? {
                  ...shop,
                  shop_config: {
                    ...shop.shop_config,
                    availability_rules,
                  },
                }
              : shop
          )
        );
        setToast("Availability rule deleted.");
      });
  };

  const saveDeliveryDiscount = (delivery_discount) => {
    return postData(
      `/api/shops/${selectedShopId}/shop_config/delivery_discounts`,
      { delivery_discount }
    )
      .then((res) => res.json())
      .then((delivery_discounts) => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId
              ? {
                  ...shop,
                  shop_config: {
                    ...shop.shop_config,
                    delivery_discounts,
                  },
                }
              : shop
          )
        );
        setToast("Delivery discount saved.");
      });
  };

  const deleteDeliveryDiscount = (name) => {
    return deleteRequest(
      `/api/shops/${selectedShopId}/shop_config/delivery_discounts/${encodeURIComponent(
        name
      )}`
    )
      .then((res) => res.json())
      .then((delivery_discounts) => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId
              ? {
                  ...shop,
                  shop_config: {
                    ...shop.shop_config,
                    delivery_discounts,
                  },
                }
              : shop
          )
        );
        setToast("Delivery discount deleted.");
      });
  };

  const saveCalendar = (calendar) => {
    return postData(`/api/shops/${selectedShopId}/shop_config/calendar`, {
      calendar,
    })
      .then((res) => res.json())
      .then((calendar) => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId
              ? {
                  ...shop,
                  shop_config: {
                    ...shop.shop_config,
                    calendar,
                  },
                }
              : shop
          )
        );
        setToast("Calendar saved.");
      })
      .catch(() => {
        setToast("Error saving calendar.");
      });
  };

  const saveSchedule = (schedule, scheduleType = 'pickup') => {
    return postData(`/api/shops/${selectedShopId}/shop_config/schedule`, {
      schedule,
      schedule_type: scheduleType,
    })
      .then((res) => res.json())
      .then((response) => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId
              ? {
                  ...shop,
                  shop_config: {
                    ...shop.shop_config,
                    pickup_schedule: response.pickup_schedule,
                    delivery_schedule: response.delivery_schedule,
                    schedule: response.pickup_schedule,
                  },
                }
              : shop
          )
        );
        setToast("Schedule saved.");
      })
      .catch(() => {
        setToast("Error saving schedule.");
      });
  };

  const updateShopConfig = (data) => {
    return putData(`/api/shops/${selectedShopId}/shop_config`, {
      shop_config: data,
    })
      .then((res) => res.json())
      .then((shop_config) => {
        setShops(
          shops.map((shop) =>
            shop.id === +selectedShopId ? { ...shop, shop_config } : shop
          )
        );
        setToast("Setting updated.");
        return shop_config;
      });
  };

  const updateOrderNotes = (orderId, note_attributes) => {
    return putData(
      `/api/shops/${selectedShopId}/orders/${orderId}/update_note`,
      { note_attributes }
    )
      .then((res) => res.json())
      .then((order) => {
        setOrders({
          ...orders,
          entities: {
            ...orders.entities,
            [orderId]: order,
          },
        });
        setToast("Order notes updated.");
      });
  };

  const sendTrackingLink = (orderId, trackingLink) => {
    return postData(
      `/api/shops/${selectedShopId}/orders/${orderId}/vendor_tracking_link`,
      { tracking_link: trackingLink }
    )
      .then((res) => res.json())
      .then((order) => {
        setOrders({
          ...orders,
          entities: {
            ...orders.entities,
            [orderId]: order,
          },
        });
        setToast("Tracking Link Sent.");
      })
      .catch(() =>
        setToast("There was an error sending tracking link. Please try again.")
      );
  };

  const cancelDelivery = (orderId) => {
    return postData(
      `/api/shops/${selectedShopId}/orders/${orderId}/cancel_delivery`
    )
      .then((res) => res.json())
      .then(({ delivery }) => {
        setDeliveries((state) => ({
          ...state,
          entities: {
            ...state.entities,
            [orderId]: delivery,
          },
        }));
        setToast("Delivery cancelled.");
      })
      .catch(() => {
        setToast(
          "Failed to cancel delivery, it may have already been processed."
        );
      });
  };

  const scheduleDelivery = (orderId, windowCode, provider) => {
    return postData(`/api/shops/${selectedShopId}/orders/${orderId}/deliver`, {
      window_code: windowCode,
      provider: provider,
    })
      .then((res) => res.json())
      .then(({ order, delivery }) => {
        setOrders((state) => ({
          ...state,
          entities: {
            ...state.entities,
            [orderId]: order,
          },
        }));
        setDeliveries((state) => ({
          ...state,
          entities: {
            ...state.entities,
            [orderId]: delivery,
          },
        }));
        setToast("Delivery scheduled.");
      })
      .catch(() => {
        setToast("Error scheduling delivery.");
      });
  };

  const changeOrderDate = (orderId, windowCode) => {
    return postData(
      `/api/shops/${selectedShopId}/orders/${orderId}/change_date`,
      { window_code: windowCode }
    )
      .then((res) => res.json())
      .then(({ order, delivery }) => {
        setOrders((state) => ({
          ...state,
          entities: {
            ...state.entities,
            [orderId]: order,
          },
        }));
        setDeliveries((state) => ({
          ...state,
          entities: {
            ...state.entities,
            [orderId]: delivery,
          },
        }));
        setToast("Date changed.");
      })
      .catch(() => {
        setToast("Error changing order date.");
      });
  };

  const setOrderTotal = (orderId, totalAmount, staffNote = null) => {
    const totalFloat = parseFloat(totalAmount || 0);
    const total_cents = Math.round(totalFloat * 100);

    return postData(
      `/api/shops/${selectedShopId}/orders/${orderId}/set_total`,
      { total_cents, staff_note: staffNote }
    )
      .then((res) => res.json())
      .then(({ order, message, overage_invoice }) => {
        if (!order) {
          throw new Error(message || "Unable to set order total.");
        }
        setOrders((state) => ({
          ...state,
          entities: {
            ...state.entities,
            [order.id]: order,
          },
        }));
        // CLV-4: when the card can't cover the new total, the server says whether Shopify
        // emailed the customer an invoice for the balance or staff must collect it.
        setToast(overage_invoice?.message || "Order total updated.");
        return order;
      })
      .catch((error) => {
        setToast(error?.message || "Error setting order total.");
        throw error;
      });
  };

  const markOrderPickedUp = (orderId) => {
    return postData(
      `/api/shops/${selectedShopId}/orders/${orderId}/mark_picked_up`
    )
      .then((res) => res.json())
      .then(({ order, message, fulfillment_error }) => {
        if (!order) {
          throw new Error(message || "Unable to mark order as picked up.");
        }
        setOrders((state) => ({
          ...state,
          entities: {
            ...state.entities,
            [order.id]: order,
          },
        }));
        if (fulfillment_error) {
          setConfirmation({
            title: "Order updated — fulfillment issue",
            content: `Status saved, but Shopify fulfillment failed:\n\n${fulfillment_error}`,
            handleOk: () => {},
            confirmText: "OK",
            cancelText: "Close",
          });
        }
        setToast(
          fulfillment_error
            ? "Picked up saved — see dialog for fulfillment details."
            : "Order marked as picked up."
        );
        return order;
      })
      .catch((error) => {
        setToast(error?.message || "Error marking order as picked up.");
        throw error;
      });
  };

  const markOrderDelivered = (orderId) => {
    return postData(
      `/api/shops/${selectedShopId}/orders/${orderId}/mark_delivered`
    )
      .then((res) => res.json())
      .then(({ order, message, fulfillment_error }) => {
        if (!order) {
          throw new Error(message || "Unable to mark order as delivered.");
        }
        setOrders((state) => ({
          ...state,
          entities: {
            ...state.entities,
            [order.id]: order,
          },
        }));
        if (fulfillment_error) {
          setConfirmation({
            title: "Order updated — fulfillment issue",
            content: `Status saved, but Shopify fulfillment failed:\n\n${fulfillment_error}`,
            handleOk: () => {},
            confirmText: "OK",
            cancelText: "Close",
          });
        }
        setToast(
          fulfillment_error
            ? "Delivered saved — see dialog for fulfillment details."
            : "Order marked as delivered."
        );
        return order;
      })
      .catch((error) => {
        setToast(error?.message || "Error marking order as delivered.");
        throw error;
      });
  };

  const downloadFromLink = async (link, filename = null, options = {}) => {
    try {
      const res = await fetcher(link, options);
      if (!res.ok) {
        const contentType = res.headers.get("content-type") || "";
        let message = `Download failed (${res.status}).`;

        if (contentType.includes("application/json")) {
          const data = await res.json().catch(() => null);
          message = data?.message || data?.error || message;
        } else {
          const text = await res.text().catch(() => "");
          if (text && !text.trim().startsWith("<")) message = text;
        }

        throw new Error(message);
      }

      const blob = await res.blob();
      window.download(blob, filename);
      return true;
    } catch (error) {
      console.log({ error });
      setToast(error?.message || "Download failed.");
      return false;
    }
  };

  const fetchBlobFromLink = async (link, options = {}) => {
    try {
      const res = await fetcher(link, options);
      if (!res.ok) {
        const contentType = res.headers.get("content-type") || "";
        let message = `Request failed (${res.status}).`;

        if (contentType.includes("application/json")) {
          const data = await res.json().catch(() => null);
          message = data?.message || data?.error || message;
        } else {
          const text = await res.text().catch(() => "");
          if (text && !text.trim().startsWith("<")) message = text;
        }

        throw new Error(message);
      }

      return await res.blob();
    } catch (error) {
      console.log({ error });
      setToast(error?.message || "Request failed.");
      return null;
    }
  };

  const emailPickupInstructions = (date) => {
    setLoadingEmailPickupInstructions(true);
    return postData(
      `/api/shops/${selectedShopId}/orders/email_pickup_instructions`,
      { date }
    )
      .then(() => setToast("Email sent."))
      .catch(() => {
        setToast("Error sending pickup instructions.");
      })
      .finally(() => setLoadingEmailPickupInstructions(false));
  };

  const changeFulfillmentLocation = (orderId, locationId) => {
    return postData(
      `/api/shops/${selectedShopId}/orders/${orderId}/change_fulfillment_location`,
      { location_id: locationId }
    )
      .then((res) => res.json())
      .then(({ order, delivery }) => {
        console.log('Received order update:', {
          orderId: order.id,
          fulfillment_order: order.fulfillment_order,
          assigned_location: order.fulfillment_order?.assigned_location,
          location_name: order.fulfillment_order?.assigned_location?.location?.name
        });
        
        setOrders((state) => ({
          ...state,
          entities: {
            ...state.entities,
            [orderId]: order,
          },
        }));
        if (delivery) {
          setDeliveries((state) => ({
            ...state,
            entities: {
              ...state.entities,
              [orderId]: delivery,
            },
          }));
        }
        setToast("Fulfillment location updated.");
      })
      .catch((error) => {
        error.json().then((data) => {
          setToast(data.message || "Error changing fulfillment location.");
        }).catch(() => {
          setToast("Error changing fulfillment location.");
        });
        throw error;
      });
  };

  const convertOrderToPickup = (orderId, locationId, prepareForPickup = false) => {
    return postData(
      `/api/shops/${selectedShopId}/orders/${orderId}/convert_to_pickup`,
      { location_id: locationId, prepare_for_pickup: prepareForPickup }
    )
      .then((res) => res.json())
      .then(({ order, delivery }) => {
        setOrders((state) => ({
          ...state,
          entities: {
            ...state.entities,
            [orderId]: order,
          },
        }));
        // Update or remove delivery
        if (delivery) {
          setDeliveries((state) => ({
            ...state,
            entities: {
              ...state.entities,
              [orderId]: delivery,
            },
          }));
        } else {
          // Remove delivery from state if it was cancelled
          setDeliveries((state) => {
            const { [orderId]: removed, ...rest } = state.entities;
            return {
              ...state,
              entities: rest,
            };
          });
        }
        setToast("Order converted to pickup.");
      })
      .catch((error) => {
        error.json().then((data) => {
          setToast(data.message || "Error converting order to pickup.");
        }).catch(() => {
          setToast("Error converting order to pickup.");
        });
        throw error;
      });
  };

  return (
    <AdminContext.Provider
      value={{
        shops,
        setShops,
        fetchShops,
        selectedShop,
        selectedShopId,
        setSelectedShopId,
        registerShop,
        registerError,
        configureShop,
        updateShop,
        fetchRates,
        rates,
        orders,
        setOrders,
        updateOrder,
        cancelDelivery,
        scheduleDelivery,
        changeOrderDate,
        changeFulfillmentLocation,
        convertOrderToPickup,
        setOrderTotal,
        markOrderPickedUp,
        markOrderDelivered,
        deliveries,
        updateOrderNotes,
        fetchShippingLabels,
        shippingLabels,
        navigateExternal,
        navigateToShopify,
        saving,
        loading,
        loadingShops,
        loadingShopData,
        saveDeliveryRate,
        deleteDeliveryRate,
        updateStoreDeliveryPostalCodes,
        updateSamedayCutoffs,
        saveAvailabilityRule,
        deleteAvailabilityRule,
        saveDeliveryDiscount,
        deleteDeliveryDiscount,
        updateShopConfig,
        saveCalendar,
        saveSchedule,
        toast,
        setToast,
        confirmation,
        setConfirmation,
        downloadFromLink,
        fetchBlobFromLink,
        sendTrackingLink,
        emailPickupInstructions,
        loadingEmailPickupInstructions,
      }}
      {...props}
    />
  );
};

const useAdmin = () => React.useContext(AdminContext);

export { AdminProvider, useAdmin };
